/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Filter_Failed_ApprovalInputs */

const en_editor_filter_failed_approval = /** @type {(inputs: Editor_Filter_Failed_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed Approval`)
};

const fr_editor_filter_failed_approval = /** @type {(inputs: Editor_Filter_Failed_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approbation echouee`)
};

const de_editor_filter_failed_approval = /** @type {(inputs: Editor_Filter_Failed_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genehmigung fehlgeschlagen`)
};

const it_editor_filter_failed_approval = /** @type {(inputs: Editor_Filter_Failed_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approvazione non riuscita`)
};

const ru_editor_filter_failed_approval = /** @type {(inputs: Editor_Filter_Failed_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не пройдена проверка.`)
};

const es_editor_filter_failed_approval = /** @type {(inputs: Editor_Filter_Failed_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprobación fallida`)
};

const zh_cn2_editor_filter_failed_approval = /** @type {(inputs: Editor_Filter_Failed_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`审批失败`)
};

const ja_editor_filter_failed_approval = /** @type {(inputs: Editor_Filter_Failed_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`承認失敗`)
};

const hi_editor_filter_failed_approval = /** @type {(inputs: Editor_Filter_Failed_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुमोदन में असफल`)
};

const pt_pt2_editor_filter_failed_approval = /** @type {(inputs: Editor_Filter_Failed_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprovação Reprovada`)
};

/**
* | output |
* | --- |
* | "Failed Approval" |
*
* @param {Editor_Filter_Failed_ApprovalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_filter_failed_approval = /** @type {((inputs?: Editor_Filter_Failed_ApprovalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Filter_Failed_ApprovalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_filter_failed_approval(inputs)
	if (locale === "de") return de_editor_filter_failed_approval(inputs)
	if (locale === "it") return it_editor_filter_failed_approval(inputs)
	if (locale === "ru") return ru_editor_filter_failed_approval(inputs)
	if (locale === "es") return es_editor_filter_failed_approval(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_filter_failed_approval(inputs)
	if (locale === "ja") return ja_editor_filter_failed_approval(inputs)
	if (locale === "hi") return hi_editor_filter_failed_approval(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_filter_failed_approval(inputs)
	return en_editor_filter_failed_approval(inputs)
});